export default {"src":"/_next/static/media/logo.169320d6.svg","height":64,"width":130,"blurWidth":0,"blurHeight":0};